import { WifiOff, RotateCw, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ConnectionError = ({ message, onRetry, onLogout }) => (
  <div className="flex flex-col items-center justify-center h-screen gap-4 px-6 text-center" data-testid="connection-error-screen">
    <WifiOff className="w-10 h-10 text-slate-400" />
    <h1 className="text-lg font-semibold text-slate-900">Verbindung zum Server fehlgeschlagen</h1>
    <p className="text-sm text-slate-500 max-w-md" data-testid="connection-error-message">
      Die Daten konnten nicht geladen werden. Bitte versuche es erneut oder melde dich neu an.
      {message ? <span className="block mt-2 text-xs text-slate-400">({message})</span> : null}
    </p>
    <div className="flex gap-3">
      <Button onClick={onRetry} data-testid="connection-error-retry-btn"><RotateCw className="w-4 h-4 mr-2" />Erneut versuchen</Button>
      <Button variant="outline" onClick={onLogout} data-testid="connection-error-logout-btn"><LogOut className="w-4 h-4 mr-2" />Abmelden</Button>
    </div>
  </div>
);
